export default "__VITE_ASSET__CoOvQxg$__"